export const capacityConstants = {
	BUILDINGS: 'buildings',
	FLOORS: 'floors',
	ROOMS: 'rooms',
};
